/* ============
 * Person Transformer
 * ============
 *
 * The transformer for a person
 */

import Transformer from './transformer'

export default class personTransformer extends Transformer {
  /**
   * Method used to transform a fetched person
   *
   * @param person The fetched person
   *
   * @returns {Object} The transformed person
   */
  static fetch (person) {
    return {
      id: person['id'],
      ppdbid: person['name'],
      name: person['displayLabel'],
    }
  }
}
